// frontend/src/pages/AboutUs.js

import React from 'react';
import { motion } from 'framer-motion';

const AboutUs = () => {
  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-12 px-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-2xl mx-auto bg-white rounded shadow-md p-8">
        <h1 className="text-3xl font-heading text-primary mb-6">
          Über Uns
        </h1>

        <p className="mb-4 leading-relaxed text-gray-700">
          Wir sind die Abschlussklasse <strong>S3b der Schule Entfelden</strong> und wir
          haben im Rahmen des Unterrichts eine Projektidee entwickelt: In unserem letzten
          Semester wollen wir das Projekt <em>„Online-Schülerzeitung Entecity.ch“</em>
          realisieren. Das Beste daran ist, dass die Zeitung <strong>online</strong> ist.
          Das bietet uns viele Möglichkeiten. Wir können nicht nur schriftliche Artikel
          veröffentlichen, sondern auch Audiobeiträge und Videos erstellen. In den
          verschiedenen Beiträgen behandeln wir die unterschiedlichsten Themen, wie
          beispielsweise lokale Ereignisse, Menschenrechte, Historisches, Sport, Soziale
          Medien und vieles mehr.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          Auf dieser journalistischen Projektseite schreiben wir über Themen, die uns als
          9. KlässlerInnen interessieren. Wir schreiben über unsere Wohnorte, bis hin zu
          wichtigen globalen Themen wie den Kinderrechten. Unser Ziel mit dem Projekt ist
          es, junge Leute zu informieren und herauszufinden, wie man Artikel schreibt.
          Ausserdem sind wir auch auf den Sozialen Medien zu finden, um unsere Reichweite
          zu steigern.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          Wir erhalten wertvolle Tipps für das journalistische Arbeiten von echten Profis,
          die uns in der Schule besuchen. Außerdem nehmen wir an aufregenden Führungen in
          verschiedenen Medienhäusern teil, wo wir die Infos sammeln, die wir brauchen. Wir
          möchten die Plattform so gestalten, dass sie auch nach unserem Abschluss von neuen
          Klassen der Oberstufe genutzt werden kann. Durch diese weitreichende Planung wird
          das Projekt auch langfristig wertvoller, denn den Lernenden nach uns ermöglichen
          wir somit einen leichteren Einstieg in das journalistische Arbeiten. Ausserdem
          haben diese zukünftig eine gute Vorlage für den Start.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          Wir sind eine engagierte Abschlussklasse der Schule Entfelden und haben uns für
          unser letztes Semester ein besonderes Projekt vorgenommen: die Gründung einer
          digitalen Schülerzeitung! Durch das Onlineformat eröffnen sich uns unzählige
          Möglichkeiten – neben klassischen Artikeln können wir auch Audiobeiträge und Videos
          erstellen. Unser Ziel ist es, spannende Inhalte zu lokalen und globalen Ereignissen
          wie Menschenrechten, Sport, sozialen Medien und vielen weiteren Themen zu liefern.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          Unsere Schülerzeitung soll nicht nur ein einmaliges Projekt bleiben, sondern zu
          einer Plattform für Lernende in Entfelden werden, die auch künftigen Klassen zur
          Verfügung steht. Deshalb legen wir grossen Wert auf Einfachheit und eine simple
          Struktur, damit kommende Jahrgänge mühelos daran anknüpfen und die Zeitung
          weiterführen können.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          Um die Qualität unserer Beiträge stetig zu verbessern, benötigen wir eure
          Unterstützung! Auf dieser Seite gibt es die Möglichkeit, unsere Klassenkasse mit
          einer Spende zu befüllen, sodass wir die Website noch professioneller gestalten
          können und Mikrofone anschaffen, mit denen wir hochwertige Inhalte produzieren
          können.
        </p>

        <p className="mb-4 leading-relaxed text-gray-700">
          Hilf uns also, gemeinsam eine lebendige, nachhaltige und inspirierende
          Schülerzeitung in Entfelden zu etablieren:
        </p>

        <p className="mb-4 font-semibold text-gray-800">
          IBAN: CH96 0076 1648 8081 0200 1
          <br />
          Klassenkasse Sek 3b Oberentfelden
          <br />
          Tramstrasse 71
          <br />
          5034 Suhr
        </p>
      </div>
    </motion.div>
  );
};

export default AboutUs;
